import { NumberInput } from "@mantine/core";
import { useInputStyles } from "./FieldTextValue";

type Props =
  | {
      formProps: any;
      label: string;
      editing: boolean;
      value?: undefined;
    }
  | {
      formProps?: undefined;
      label: string;
      editing?: undefined;
      value: number | string | null | undefined;
    };

export default function FieldNumberValue({
  editing,
  formProps,
  value,
  label,
}: Props) {
  const { classes } = useInputStyles();
  const displayValue = value !== undefined && value !== null ? value : formProps?.value;
  return (
    <NumberInput
      label={label}
      disabled={!editing}
      size="md"
      variant="default"
      {...formProps}
      classNames={{ input: classes.input, label: classes.label }}
      value={formProps?.value !== undefined ? formProps.value : displayValue}
    />
  );
}
